export type JobApplicationCountRow = {
  job_id: string;
  stage?: string | null;
  status?: string | null;
  source?: string | null;
  cv_scores?: { total_score?: number | null } | Array<{ total_score?: number | null }> | null;
};

const HIDDEN_CV_SCORING_STATUSES = new Set([
  'cv_scoring_pending',
  'cv_scoring_failed',
  'duplicate_review_pending',
  'rejected_unreadable',
]);

const REVIEW_QUEUE_STATUSES = new Set([
  'cv_scoring_pending',
  'cv_scoring_failed',
]);

const REVIEW_QUEUE_SOURCES = new Set([
  'public_application',
  'invited',
]);

function scoreFor(row: JobApplicationCountRow) {
  if (Array.isArray(row.cv_scores)) return row.cv_scores[0]?.total_score ?? null;
  return row.cv_scores?.total_score ?? null;
}

export function isVisibleJobCardApplication(row: JobApplicationCountRow) {
  const status = row.status ?? '';
  const source = row.source ?? '';
  const isRecruiterReviewQueueApplication =
    REVIEW_QUEUE_STATUSES.has(status) && REVIEW_QUEUE_SOURCES.has(source);

  if (HIDDEN_CV_SCORING_STATUSES.has(status) && !isRecruiterReviewQueueApplication) {
    return false;
  }

  if (row.stage === 'applied' && scoreFor(row) == null && !isRecruiterReviewQueueApplication) {
    return false;
  }

  return true;
}

export function buildJobApplicationCounts(
  jobIds: string[],
  rows: JobApplicationCountRow[],
) {
  const counts: Record<string, number> = Object.fromEntries(jobIds.map((jobId) => [jobId, 0]));

  rows.forEach((row) => {
    if (!Object.prototype.hasOwnProperty.call(counts, row.job_id) || !isVisibleJobCardApplication(row)) return;
    counts[row.job_id] += 1;
  });

  return counts;
}
